jQuery(document).ready(function ($) {
    const locationGallery = new Swiper('.js-location-gallery', {
        loop: true,

        slidesPerView: 1,

        autoplay: true,
        delay: 4000,

        grabCursor: true,

        pagination: {
            el: '.related-properties__images--pagination',

            bulletClass: 'pagination-bullet',
            bulletActiveClass: 'active',

            clickable: true,
        },

        navigation: {
            prevEl: '.related-properties__images--prev',
            nextEl: '.related-properties__images--next'
        },

        slideClass: 'related-properties__image'
    });
});